<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-4">
                <DashCard :value="trafficTotal" :label="$t('statistic.traffic')" icon="users"/>
            </div>
            <div class="col-md-4">
                <DashCard :value="approvedTotal" :label="$t('statistic.approve')" icon="thumbs-o-up" bg="success">
                    <template slot="percents"><small style="color: #fff">{{ approvedPercents }}</small></template>
                </DashCard>
            </div>
            <div class="col-md-4" v-if="Auth.haveAccess('DASH_ADVERTISE_DEBIT')">
                <DashCard :value="`${adverticeDebit}$`" :label="$t('statistic.debt')" icon="hand-lizard-o" />
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <TrafficChart :chartData="trafficChart"/>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-md-6 col-xs-12 otherResponsive">
                <DifferencyTable :tableData="averageBillTable" :title="$t('statistic.averageBill')" symbol="$"
                                 icon="usd" :calculate="true" :withAverage="true"/>
            </div>

            <div class="col-xl-6 col-md-6 col-xs-12 otherResponsive">
                <DifferencyTable :tableData="approveTable" :title="$t('statistic.approve')" symbol="%" color="warning"
                                 icon="thumbs-o-up" :calculate="true" :withAverage="true"/>
            </div>

            <div class="col-xl-6 col-md-12 col-xs-12 leadsResponsive">
                <DifferencyTable :isLeads="true" :tableData="leadsForDash" :title="$t('statistic.leads')" color="success" icon="users"
                                 :calculate="true"/>`
            </div>

            <div class="col-xl-12 col-md-12 col-xs-12" v-if="Auth.haveAccess('DASH_ADVERTISE_DEBIT')">
                <DebitTable :tableData="adverticeDbt" :title="$t('statistic.debt')" color="primary" icon="hand-lizard-o"/>
            </div>
        </div>
    </div>
</template>

<script>
  import DifferencyTable from '../components/DifferencyTable'
  import DebitTable from '../components/DebitTable'
  import TrafficChart from '../components/TrafficChart'
  import Storage from './../api/Storage'
  import DashCard from '../components/DashCard.vue'
  import Auth from '@/api/Auth'
//  import Helper from '@/api/Helper'
  import { map } from 'lodash'

  export default {
    name: 'dashboard',
    components: {
      DifferencyTable,
      TrafficChart,
      DashCard,
      DebitTable
    },
    data () {
      return {
        Auth: Auth,
        trafficChart: Storage.dashboardStatistic.traffic,
        averageBillTable: Storage.dashboardStatistic.average_bill,
        approveTable: Storage.dashboardStatistic.approve,
        adverticeDbt: Storage.dashboardStatistic.advertising_debt
      }
    },
    computed: {
      adverticeDebit () {
        let total = 0.0
        map(this.adverticeDbt, (d, i) => {
          total += parseFloat(d.balance)
        })
        return parseFloat(total).toFixed(2)
      },
      trafficTotal () {
        let total = 0
        map(this.trafficChart.values, (d) => {
          total += d[d.length - 1]
        })
        return total
      },
      approvedTotal () {
        let total = 0
        map(this.approveTable, (d) => {
          total += d.count
        })
        return total
      },
      approvedPercents () {
        return `${parseFloat((this.approvedTotal / this.trafficTotal) * 100).toFixed(1)}%`
      },
      leadsForDash () {
        let data = Storage.dashboardStatistic.leads
        map(data, (d, i) => {
          data[i].difference = data[i].weekAverage - data[i].limit
        })
        return data
      }
    }
  }
</script>
<style scoped>
    @media (min-width: 1300px) and (max-width: 1360px) {
        .leadsResponsive {
            width: 50%;
        }
        .otherResponsive {
            width: 50%;
        }
    }
    @media (min-width: 1400px) {
        .leadsResponsive {
            width: 40%;
        }
        .otherResponsive {
            width: 29.9%;
        }
    }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?5424068e